import {
  BOOK_STEPS,
  bookStepIndex,
  type BookStepId,
} from '../../lib/book-flow'

export interface BookStepsProps {
  activeStep: BookStepId
}

export function BookSteps({ activeStep }: Readonly<BookStepsProps>) {
  const activeIndex = bookStepIndex(activeStep)

  return (
    <nav aria-label="Booking progress" className="booking-steps book-steps">
      {BOOK_STEPS.map((step, index) => (
        <div
          aria-current={step.id === activeStep ? 'step' : undefined}
          className={index <= activeIndex ? 'active' : ''}
          key={step.id}
        >
          <span>{index + 1}</span>
          <strong>{step.label}</strong>
        </div>
      ))}
    </nav>
  )
}
